export default class KindergartenGroup {
    static fromData(data) {
        if (!data) {
            return;
        }

        const kindergartenGroup = new KindergartenGroup();
        kindergartenGroup.id = data.id;
        kindergartenGroup.name = data.name;

        return kindergartenGroup;
    }
}
